import React, {useEffect} from 'react';
import AppButton from '../../../components/app-button';
import Header1 from '../../../components/headers/header1';
import ModalTemplate from '../../../components/modal';
import ClaimItemsFilter, {ClaimItemsFilterProps} from './ClaimItemsFilter';
import * as fonts from '../../../util/fonts';
import colors from '../../../util/colors';
import './styles.scss';
import { connect } from 'react-redux';
import { compose } from 'redux';

export interface ClaimsFilterModalProps {
  showFilterModal: boolean;
  setShowFilterModal(show: boolean): void;
  filterProps: ClaimItemsFilterProps;
  setFilter: any;
  modalWasClosed: () => void;
  labels: any;
}

function ClaimsFilterModal(props: ClaimsFilterModalProps) {
  useEffect(() => {
    var newFilter = {...props.filterProps};
    newFilter.filtersHaveChanged = false;
    props.setFilter(newFilter);
  }, []);

  const filterChanged = (parm: string, value: string | Date) => {
    var newFilter = {...props.filterProps};
    (newFilter as any)[parm] = value;
    (newFilter as ClaimItemsFilterProps).filtersHaveChanged = true;
    props.setFilter(newFilter);
  };

  const closeAndApply = () => {
    props.setShowFilterModal(false);
    props.modalWasClosed();
  };

  return (
    <ModalTemplate
      show={props.showFilterModal}
      onHide={() => props.setShowFilterModal(false)}
      hideFooter={true}
      className="filter-modal">
      <Header1
        className="filter-modal-header"
        style={{...fonts.L, color: colors.black}}>
        {props.labels?.filterTitle}
      </Header1>
      <ClaimItemsFilter
        controlLabels={props.filterProps.controlLabels}
        filterOneOptions={props.filterProps.filterOneOptions}
        filterTwoOptions={props.filterProps.filterTwoOptions}
        filterParameterChanged={filterChanged}
        filterParmOne={props.filterProps.filterParmOne}
        filterParmTwo={props.filterProps.filterParmTwo}
        filtersHaveChanged={props.filterProps.filtersHaveChanged}
        periodFrom={props.filterProps.periodFrom}
        periodTill={props.filterProps.periodTill}
      />

      <AppButton className="filter-modal-button-submit" onClick={closeAndApply}>
        {props.labels?.filterButtonText}
      </AppButton>
    </ModalTemplate>
  );
}


const mapStateToProps = ({ strings}: any) => ({
  labels: strings.value.pt.refund
});


export default compose(
  connect(mapStateToProps)(ClaimsFilterModal)
);

